import { AppConfigModel } from "../abstract/app-config.model";

export class Frequency extends AppConfigModel {

    static override CLASS_NAME: string = 'Frequency';
}
